module.exports = __webpack_public_path__ + "img/verify-illus.ba1b0142.svg";